// src/firebaseConfig.js

// --- Firebase SDK Imports ---
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// import { getStorage, connectStorageEmulator } from 'firebase/storage';


// --- YOUR ACTUAL FIREBASE PROJECT CONFIGURATION ---
// !!! IMPORTANT: REPLACE these placeholder values with the exact ones you copied from your Firebase Console.
export const firebaseConfig = {
  apiKey: "AIzaSyBVOX0lBOgggDanOuqTzEL3B0FY7_LyjPE",
  authDomain: "guided-botswana.firebaseapp.com",
  projectId: "guided-botswana",
  storageBucket: "guided-botswana.firebasestorage.app",
  messagingSenderId: "488260239279",
  appId: "1:488260239279:web:3abc1e2550961d356e795a",
  measurementId: "G-VZQ51L82K5"
};


// --- Initialize the Firebase App ---
const app = initializeApp(firebaseConfig);


// --- Get Instances of Firebase Services ---
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
// const storage = getStorage(app);


// --- Connect to Firebase Emulators during Local Development ---
if (window.location.hostname === "localhost") {
  console.log("🔥 Connecting to Firebase Emulators...");

  connectAuthEmulator(auth, "http://127.0.0.1:8004");
  connectFirestoreEmulator(db, "127.0.0.1", 8002);
  connectFunctionsEmulator(functions, "127.0.0.1", 8001);
  // connectStorageEmulator(storage, "127.0.0.1", 9199);
}


// --- Export the Initialized Services ---
export { app, auth, db, functions };
// export { app, auth, db, functions, storage };
